import { getAnalytics, logEvent, setUserProperties } from 'firebase/analytics';
import firebaseApp from './initialize';

// GA4 is initialized only in real deployed analytics environments. Local builds
// (which symlink the prod Firebase config) and any env without a measurement ID
// fall through to the catch and stay disabled.
// NOTE: staging is intentionally excluded for now because it shares the same
// REACT_APP_FIREBASE_MEASUREMENT_ID as production — enabling it would pollute the
// prod GA4 stream. Add 'staging' here once it has its own measurement ID.
const ANALYTICS_ENABLED_ENVIRONMENTS = ['production'];

let analytics;
try {
  if (ANALYTICS_ENABLED_ENVIRONMENTS.includes(process.env.REACT_APP_ENVIRONMENT)) {
    analytics = getAnalytics(firebaseApp);
  }
} catch (e) {
  analytics = undefined;
}

const analyticsDecorator = (func) => {
  if (firebaseAnalytics.analyticsExist) {
    func();
  }
}

const firebaseAnalytics = {
  analyticsExist: analytics !== undefined,
  logEvent: (eventName, eventParams) => {
    analyticsDecorator(
      () => logEvent(analytics, eventName, eventParams)
    );
  },
  setUserProperties: (properties) => {
    analyticsDecorator(
      () => setUserProperties(analytics, properties)
    );
  }
}

const logFlowEvent = (eventName, flowName, extraParams = {}) => {
  const {action, ...rest} = extraParams;
  firebaseAnalytics.logEvent(eventName, {
    flow_name: flowName,
    platform: 'web',
    ...rest,
    // Some call sites pass backend enum values (e.g. 'PAUSE'); keep GA4 values lowercase.
    ...(action !== undefined && {action: typeof action === 'string' ? action.toLowerCase() : action}),
  });
};

export { firebaseAnalytics, logFlowEvent };
